import { makeAutoObservable } from 'mobx';
import PricingPlan from './PricingPlan';

class Scooter {

  id = null;
  latitude = 0;
  longitude = 0
  battery = 0;
  uuid = null;
  vehicleModel = null;
  kind = null;
  pricingPlans = null;
  organizationId = null;
  

  constructor({
    id,
    latitude,
    longitude,
    battery,
    uuid,
    vehicle_model,
    kind,
    organization_id
  }, plans) {
    this.id = id;
    this.latitude = latitude;
    this.longitude = longitude;
    this.battery = battery;
    this.uuid = uuid;
    this.vehicleModel = vehicle_model;
    this.kind = kind;
    this.pricingPlans = plans?.map(plan => new PricingPlan(plan));
    this.organizationId = organization_id;

    makeAutoObservable(this);
  }

  isHonolulu() {
    return this.organizationId === 202;
  }

}


export default Scooter;
